var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6C30.8354 6 38 13.1633 38 22C38 30.8367 30.8367 38 22 38C13.1646 38 6 30.8367 6 22C6 13.1633 13.1646 6 22 6ZM20.6342 15.0314V22.001C20.6342 22.5063 20.9079 22.9471 21.3158 23.1839L27.2078 26.5877C27.8618 26.9666 28.6986 26.743 29.0776 26.089C29.4565 25.435 29.2328 24.5982 28.5789 24.2193L23.3656 21.2087V15.031C23.3656 14.2758 22.755 13.6652 21.9998 13.6652C21.2445 13.6652 20.634 14.2771 20.634 15.031L20.6342 15.0314ZM31.3751 12.6262C26.1975 7.44856 17.8041 7.44856 12.6265 12.6262C7.44886 17.8024 7.44886 26.1972 12.6265 31.3748C17.8027 36.5524 26.1975 36.5524 31.3751 31.3748C36.5527 26.1972 36.5527 17.8038 31.3751 12.6262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.f8106f7f69870ef604b6f7396e307d35.svg";
export { ForwardRef as ReactComponent };